import { createRestAPIModelGenerator } from 'src/data/models/generator';
export const TYPE = 'timezones';

const TimezonesGenerator = createRestAPIModelGenerator(TYPE);
export default TimezonesGenerator.createValueListModel();
